import { CategorySection } from "./categoryConfig";

export type Season = "Spring" | "Summer" | "Autumn" | "Winter";

const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
] as const;

const SEASON_ORDER: Season[] = ["Spring", "Summer", "Autumn", "Winter"];

const MONTH_TO_SEASON: Record<string, Season> = {
  January: "Winter",
  February: "Winter",
  March: "Spring",
  April: "Spring",
  May: "Spring",
  June: "Summer",
  July: "Summer",
  August: "Summer",
  September: "Autumn",
  October: "Autumn",
  November: "Autumn",
  December: "Winter",
};

/**
 * Get the current month name (e.g., "January")
 */
export function getCurrentMonth(): string {
  const monthIndex = new Date().getMonth();
  return MONTH_NAMES[monthIndex];
}

/**
 * Get the current season based on the month
 */
export function getCurrentSeason(): Season {
  const currentMonth = getCurrentMonth();
  return MONTH_TO_SEASON[currentMonth];
}

/**
 * Reorder sections so the current season appears first
 */
export function getOrderedSeasonalSections(sections: CategorySection[]): CategorySection[] {
  const currentSeason = getCurrentSeason();
  
  // Find the index of the current season
  const currentSeasonIndex = sections.findIndex(
    (section) => section.title === currentSeason
  );
  
  if (currentSeasonIndex === -1) {
    // Fallback: return original order if current season not found
    return sections;
  }
  
  // Reorder: current season first, then wrap around
  const reordered = [
    ...sections.slice(currentSeasonIndex),
    ...sections.slice(0, currentSeasonIndex),
  ];
  
  return reordered;
}

/**
 * Check if a month name matches the current month
 */
export function isCurrentMonth(monthName: string): boolean {
  return monthName.toLowerCase() === getCurrentMonth().toLowerCase();
}

/**
 * Check if a season is the current season
 */
export function isCurrentSeason(seasonTitle: string): boolean {
  return seasonTitle === getCurrentSeason();
}
